<template>
  <div>
    {{unidades}}
    <LineChartGenerator
    :chart-options="chartOptionsMutado"
    :chart-data="chartData"
  />
  </div>
 
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import zoomPlugin from 'chartjs-plugin-zoom';

import annotationPlugin from 'chartjs-plugin-annotation';
import {mapState} from 'vuex'
import 'chartjs-adapter-moment';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
  Legend,
  TimeScale

} from 'chart.js'

ChartJS.register(  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  zoomPlugin,
  Legend,
  annotationPlugin,
  CategoryScale,
  TimeScale
)

  // Deshabilitar la leyenda globalmente
ChartJS.defaults.plugins.legend.display = false;

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator,
  },
  props: {
    unidades:String,
    chartData: {
      labels:Array,
      datasets: Array,
    },
    chartOptions: {
      type: Object,
      required: true
    },
    baseLineValue: {
      type: Number,
      required: false,
      default: 0
    },
    plugins: {
      type: Array,
      default: () => []
    },
    tromel:Boolean,
    temp1_configuracion:String,
    temp2_configuracion:String,
  },
  methods: {
    kk(v){
      return `kk ${v}`
    }
  },
  computed: {
    ...mapState([
        'higienizacion1',
        'higienizacion2',
    ]),
    chartOptionsMutado() {

      

      let k = {
        plugins: {
          title: {
            display: true,
            font: {
              size: 18
            }
          },
          legend: {
            display: true,
            position: 'top',
            labels: {
              font: {
                size: 14
              },
              usePointStyle: true,
            },
            onClick: (event, legendItem, legend) => {
              const chart = legend.chart;
              const datasetIndex = legendItem.datasetIndex;

              // Cambia la propiedad hidden del dataset
              chart.data.datasets[datasetIndex].hidden = !chart.data.datasets[datasetIndex].hidden;

              // Actualiza el gráfico
              chart.update();
            }
          },
          annotation:{
            annotations:{
              line1: {
                type: 'line',
                yMin: this.baseLineValue, // Usa el valor de la propiedad `baseLineValue`
                yMax: this.baseLineValue, 
                borderColor: 'rgb(0, 0, 0)',
                borderWidth: 2,
              },
            }
          } ,
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
              pan: {
                enabled: true
              },
              drag: {
                enabled: true
              }
            }
          },
          tooltip: {
            enabled: true,
            mode: 'nearest',
            intersect: false,
            callbacks: {
              label: function (context) {
                const datasetLabel = context.dataset.label || ''; // Nombre del dataset
                const value = context.parsed.y; // Valor actual del punto
                const axisId = context.dataset.yAxisID; // Identifica el eje Y correspondiente

                // Determina la unidad según el eje
                let unit = '';
                if (axisId === 'y' || axisId === 'y2') {
                  unit = '°C'; // Para los ejes de temperatura
                } else if (axisId === 'y3') {
                  unit = 'Hz'; // Para el eje de velocidad
                }

                // Devuelve el texto del tooltip con la unidad correcta
                const formattedValue = typeof value === 'number' ? value.toFixed(context.dataset.precision || 0) : value;
                return `${datasetLabel}: ${formattedValue} ${unit}`;
              }
            }
          }
        },
        animation: {
          duration: 0
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            type: 'time',
            title: {
              display: true,
              text: 'Horas'
            },
            time: {
              tooltipFormat: 'HH:mm',
              displayFormats: {
                minute: 'HH:mm'
              }
            },
            padding: {
              left: 40,
              right: 40
            }
          },
          y: {
            id: 'y',
            title: {
              display: true,
              text: 'Temperatura (°C) - Trabajo'
            },
            padding: {
              bottom: 100,
              top: 100
            },
            pan: {
              enabled: true,
              mode: 'y'
            },
            ticks: {
              callback: function(value) {
                return `${value} °C`;
              }
            }
          },
          y2: {
            id: 'y2',
            position: 'right',
            title: {
              display: true,
              text: 'Temperatura (°C) - Horno'
            },
            padding: {
              bottom: 100,
              top: 100
            },
            pan: {
              enabled: true,
              mode: 'y'
            },
            grid: {
              drawOnChartArea: false // Evita que las líneas de la rejilla se superpongan
            },
            ticks: {
              callback: function(value) {
                return `${value} °C`;
              }
            }
          },
          y3: {
            id: 'y3',
            position: 'left',
            title: {
              display: true,
              text: 'Hz'
            },
            min: 0,
            max: 50,
            grid: {
              drawOnChartArea: false // Evita que las líneas de la rejilla se superpongan con y
            },
            ticks: {
              callback: function(value) {
                return `${value} Hz`;
              }
            }
          }
        }
      };

      return k;
    }

  },

  data() {

    return {
     

    }
  },
}
</script>